import React from "react";
import { Form } from "react-bootstrap";

import { RequiredMark, Skeleton, SelectAsync } from "components";
import { DebounceTimeout } from "globalConstants";

import styles from "../selectAsync.module.scss";

const SelectAsyncForPrimaryAgent = ({
	input,
	meta,
	loadOptions,
	findOption,
	onChangeCb,
	loading,
	preselect = {},
	...props
}) => {
	const handleChange = option => {
		input.onChange(option.value);
		if (onChangeCb) onChangeCb(option);
	};

	const handleBlur = () => {
		input.onBlur(input.value);
	};

	const showLoader =
		loading || (loading === undefined && !loadOptions.length);

	return (
		<Form.Group>
			<Form.Label>
				Primary agent
				<RequiredMark />
			</Form.Label>
			<div className={styles.selectLoaderContainer}>
				{showLoader && (
					<Skeleton
						height="38px"
						className={styles.selectLoaderContainerSkeleton}
					/>
				)}
				<SelectAsync
					{...props}
					value={findOption(input.value) || preselect}
					loadOptions={loadOptions}
					onChange={handleChange}
					onBlur={handleBlur}
					debounceTimeout={DebounceTimeout}
					cacheOptions
					additional={{ page: 0 }}
					hasError={meta.touched && meta.error}
					isSearchable
				/>
			</div>
			{meta.touched && meta.error && (
				<Form.Control.Feedback type="invalid" className="d-block">
					{meta.error}
				</Form.Control.Feedback>
			)}
		</Form.Group>
	);
};

export default SelectAsyncForPrimaryAgent;
